import { useEffect } from 'react'

import { FormikProps } from 'formik'

import { FormFieldConfig } from '../features/ui-config'

/**
 * A custom React Hook that check if there is only one item in the options
 * and if so selects the first item in formik.
 *
 * @param {string} field - The name of the field in formik to be updated.
 * @param {FormFieldConfig['options']} fieldConfigOptions - The available options for the field.
 * @param {FormikProps<any>} formik - The Formik object containing form methods and states.
 * @param {boolean} [updateValueNow=true] - When set to false, it will wait to select the first option until it changes to true.
 */

export const useSelectFirstAndOnlyOption = (
  field: string,
  fieldConfigOptions: FormFieldConfig['options'],
  formik: FormikProps<any>,
  updateValueNow: boolean = true,
): void => {
  useEffect(() => {
    // Check if there is only one item in the options
    if (fieldConfigOptions?.length === 1) {
      // If we should wait for the update we step out now
      if (!updateValueNow) return
      const value = fieldConfigOptions[0].code
      // If there is only one item than select it in formik
      formik.setFieldValue(field, value)
    }
  }, [fieldConfigOptions, formik.values[field], updateValueNow])
}
